import React from 'react';
import {Image, PageHeader} from 'antd';

const Preferences = () => {
    return (
        <>
            <PageHeader
                className="site-page-header"
                title="Настройки пользователя"
            />
            <p>В верхней части приложения находятся переключатели для выбора различных пользовательских настроек</p>
            <Image
                width={800}
                src="https://res.cloudinary.com/dv4fxot90/image/upload/v1601228616/documentation/Screenshot_2020-09-27_at_20.42.19_lsxdom.png"
            /><br/><br/>
            <h3>Компонент UserSettings отвечает за пользовательские настройки внешнего вида</h3><br/>
            <p>Кнопка с иконкой Settings открывает выдвижную форму(Drawer)</p>
            <Image
                width={800}
                src="https://res.cloudinary.com/dv4fxot90/image/upload/v1601228616/documentation/Screenshot_2020-09-27_at_20.43.11_mtpqpn.png"
            /><br/><br/>
            <p>Компонент <code>SettingsFontSize</code> - позволяет пользователю  вкл/выкл режим для слабовидящих (увеличивает размер шрифта, делает шрифт более жирным)</p>
            <p>Компонент <code>SettingsTagColor</code> - позволяет пользователю поменять цвет тэгов (для каждого тэга цвет устанавливается отдельно)</p>
            <p>Компонент <code>SettingsTheme</code> - позволяет пользователю поменять тему со светлой на тёмную.</p>
            <h3>Верхняя панель с селектами:</h3><br/>
            <p>Time zone switch<br/>
                Предназначен для выбора часового пояса пользователя, изначально стоит Europe/Minsk,<br/>
                можно выбрать из: London, Warsaw, Kiev, Minsk, Moskow, Volgograd, Yekaterinburg, Tashkent
            </p>
            <Image
                width={200}
                src="https://res.cloudinary.com/dv4fxot90/image/upload/v1601222148/docs/Screenshot_2020-09-27_at_18.55.30_z63ktd.png"
            /><br/><br/>
            <p>	Schedule mode switch<br/>
                Выбор вида расписания, можно выбрать из: Table, List, Calendar<br/>
                Table для просмотра всех данных на компьютере, List удобен на мобильных платформах,<br/>
                Calendar чтобы следить за расписанием в виде календаря </p>
            <Image
                width={150}
                src="https://res.cloudinary.com/dv4fxot90/image/upload/v1601221385/docs/Screenshot_2020-09-27_at_18.41.53_olavm8.png"
            /><br/><br/>
            <p>	Week Switch<br/>
                Определяет отображения данных в Table и Row, вы можете выбрать из: previous week, this week
                next week, all schedule</p>
            <Image
                width={150}
                src="https://res.cloudinary.com/dv4fxot90/image/upload/v1601221384/docs/Screenshot_2020-09-27_at_18.42.06_uutmq1.png"
            /><br/><br/>
            <p>	User mode switcher<br/>
                Предназначен для переключения пользователя (администратор или студент) чтобы продемонстрировать возможности приложения<br/>
                В режиме администратора доступно редактирование данных и добавление новых задач</p>
            <Image
                width={80}
                src="https://res.cloudinary.com/dv4fxot90/image/upload/v1601221384/docs/Screenshot_2020-09-27_at_18.42.27_gsyuzl.png"
            /><Image
                width={80}
                src="https://res.cloudinary.com/dv4fxot90/image/upload/v1601221384/docs/Screenshot_2020-09-27_at_18.42.15_qcoc64.png"
            /><br/><br/>
            <p>	Columns switch<br/>
                Предназначен для скрытия/отображения колонок таблицы</p>
            <Image
                width={100}
                src="https://res.cloudinary.com/dv4fxot90/image/upload/v1601221384/docs/Screenshot_2020-09-27_at_18.42.40_qh1lmj.png"
            /><br/><br/>
            <h3>Redux-persist</h3>
            <p>Все выбранные пользователем данные, отвечающие за настройки отображения, попадают в редьюсеры и с помощью библиотеки redux-persist записываются пользователю в <code>localStorage</code></p>
            <p>Чтобы добавить редьюсер к сохраняемым в <code>localStorage</code>, нужно в <code>src/redux/store.ts</code> добавить этот редьюсер в persistConfig:</p>
            <code>
                'const persistConfig = &#123;<br/>
                    key: 'root',<br/>
                    storage,<br/>
                    whitelist: ['userPreferences', 'importantColData','hideColumnData'],<br/>
                &#125;
            </code>
        </>
    );
};

export default Preferences;